<template>
  <div class="addDepartment">
    <el-dialog
      :title="$t('company.insertDepartment')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="580px"
    >
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('company.departmentInfo')">
          <!--部门信息-->
          <el-form
            label-width="100px"
            ref="departmentDialog"
            :label-position="'right'"
            :rules="rules"
            :model="addInfo"
          >
            <el-form-item :label="$t('company.detail.departmentName')" prop="createDepartmentName">
              <el-input
                v-model="addInfo.createDepartmentName"
                class="inputWidth"
                clearable
                :maxlength="64"
                :placeholder="$t('company.departmentNamePlaceholder')"
              ></el-input>
            </el-form-item>
            <!-- 增加部门编码 -->
            <el-form-item :label="$t('company.detail.departmentCode')" prop="createDepartmentCode">
              <el-input
                v-model="addInfo.createDepartmentCode"
                class="inputWidth"
                clearable
                :maxlength="64"
                :placeholder="$t('department.search.departmentCodePlaceholder')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company.detail.companyIndex')" prop="sortOrder">
              <el-input-number
                v-model="addInfo.sortOrder"
                controls-position="right"
                class="inputWidth"
                :min="0"
                :max="999"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('company.detail.receiptClaimMode')" prop="receiptClaimMode">
              <el-select
                filterable
                class="inputWidth"
                v-model="addInfo.receiptClaimMode"
                :placeholder="$t('company.search.receiptClaimMode')"
                clearable
              >
                <el-option
                  v-for="item of receiptClaimModeList"
                  style="width: 100%"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="department-content" style="margin-bottom: 10px">
            {{ this.$t('company.higherDepartmentTitle') }}
          </div>
          <!---可编辑表格-->
          <vxe-table
            border
            size="mini"
            show-overflow
            show-header-overflow
            ref="unitTable"
            :data="unitData"
            :edit-rules="validRules"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
          >
            <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
            <vxe-table-column
              field="superiorUnitCode"
              :title="$t('company.table.unitName')"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <treeselect
                  :options="options"
                  v-model="scope.row.superiorUnitCode"
                  :defaultExpandLevel="Infinity"
                  openDirection="auto"
                  :clearable="false"
                  :maxHeight="200"
                  :zIndex="2999"
                  :flat="true"
                  :append-to-body="true"
                  @select="(val) => selectNode(val, scope)"
                  @input="(val) => inputChange(val, scope)"
                  :placeholder="$t('company.treeselect.searchIndex')"
                  :noResultsText="$t('company.treeselect.noData')"
                  :searchPromptText="$t('company.treeselect.searchIndex')"
                />
              </template>
              <template v-slot="{ row }">{{ row.superiorUnit }}</template>
            </vxe-table-column>
          </vxe-table>
          <!--控制范围-->
          <div class="department-content control-content">
            {{ this.$t('company.controlTitle') }}
          </div>
          <!--新增/删除按钮-->
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
                >{{ $t('xTable.insert') }}</vxe-button
              >
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="deleteEvent()"
                >{{ $t('xTable.delete') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            size="mini"
            show-overflow
            show-header-overflow
            ref="xTable"
            class="edit-table"
            :data="tableData"
            :edit-rules="validControlRules"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
            @cell-click="cellClick"
          >
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
            <vxe-table-column
              field="controlAreaCode"
              :title="$t('company.table.controlareaName')"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-select
                  style="width: 100"
                  clearable
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  v-model="scope.row.controlAreaCode"
                  :placeholder="$t('company.controlAreaPlaceholder')"
                  @change="(val) => changeControl(val, scope)"
                >
                  <el-option
                    v-for="item in controlAreaList"
                    :key="item.controlAreaCode"
                    :label="item.controlAreaName + '(' + item.controlAreaCode + ')'"
                    :value="item.controlAreaCode"
                  ></el-option>
                </el-select>
              </template>
              <template v-slot="{ row }">{{
                row.controlAreaName || getSelectLabel(row.controlAreaCode)
              }}</template>
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('company.system')">系统映射表</el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import { isEqual } from '@/common/js/util';
  import XEUtils from 'xe-utils';
  export default {
    name: 'addDepartment',
    data() {
      return {
        dialogAdd: false,
        detail: {},
        loading: false,
        addInfo: {
          sortOrder: 0,
          createDepartmentName: null,
          createDepartmentCode: null,
          receiptClaimMode: 'C',
        },
        //上级单位
        unitData: [],
        options: [],
        node: {},
        allControlAreaList: [],
        controlAreaList: [],
      };
    },
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          createDepartmentName: [
            {
              required: true,
              message: this.$t('company.departmentNameNotEmpty'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          receiptClaimMode: [
            {
              required: true,
              message: this.$t('company.search.receiptClaimMode'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
      validRules() {
        return {
          superiorUnitCode: [{ required: true, message: this.$t('company.UnitNotEmpty') }],
        };
      },
      validControlRules() {
        return {
          controlAreaCode: [{ required: true, message: this.$t('company.controlAreaNotEmpty') }],
        };
      },
    },
    methods: {
      openDialog(flag, detail) {
        this.detail = detail;
        this.options = [];
        this.node = {};
        this.unitData = [this.detail];
        this.loading = false;
        this.dialogAdd = flag;
        if (this.$refs['departmentDialog']) {
          this.$refs['departmentDialog'].resetFields();
        }
        //初始化上级单位
        this.initDepartment();
        //初始化控制范围
        this.initControlArea();
      },
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
          treeFlag: 1,
        };
        this.$axios.post(API.LIST_COMPANY_API, params).then((res) => {
          if (0 == res.data.code) {
            this.options = res.data.data;
            this.getSelectedNode(this.options, this.options);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      initControlArea() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
        this.$axios.post(API.GET_CONTROL_AREA_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.allControlAreaList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //模糊搜索
      remoteMethod(query) {
        if (query != '') {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            controlAreaName: query ? query : null,
          };
          this.$axios.post(API.GET_CONTROL_AREA_LIST, params).then((res) => {
            if (0 == res.data.code) {
              this.controlAreaList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.controlAreaList = [];
        }
      },
      //选中节点
      selectNode(node, scope) {
        this.node = node;
        scope.row.superiorUnit =
          node.attributes.createCompanyName || node.attributes.createDepartmentName;
        this.$refs.unitTable.updateStatus(scope);
      },
      //清空之后
      inputChange(value, scope) {
        if (!value) {
          scope.row.superiorUnit = null;
          scope.row.superiorUnitCode = null;
          this.$refs.unitTable.updateStatus(scope);
        }
      },
      //新增一行
      insertEvent() {
        const tableList = this.$refs.xTable.getTableData().fullData;
        if (tableList.length == 0) {
          this.$refs.xTable
            .validate()
            .then((errMap) => {
              console.log(errMap);
              this.controlAreaList = [];
              const record = {
                controlAreaCode: null,
                controlAreaName: null,
              };
              this.$refs.xTable
                .insert(record)
                .then(({ row }) => this.$refs.xTable.setActiveRow(row));
            })
            .catch((errMap) => {
              console.log(errMap);
            });
          // this.$refs.xTable.validate((valid) => {
          //   if (valid) {
          //     this.controlAreaList = [];
          //     const record = {
          //       controlAreaCode: null,
          //       controlAreaName: null,
          //     };
          //     this.$refs.xTable
          //       .insert(record)
          //       .then(({ row }) => this.$refs.xTable.setActiveRow(row));
          //   }
          // });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneChange'),
            type: 'error',
          });
        }
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //点击单行，默认赋值全部
      cellClick() {
        this.controlAreaList = this.allControlAreaList;
      },
      //根据code匹配出name
      getSelectLabel(value, valueProp = 'controlAreaCode', labelField = 'controlAreaName') {
        let item = XEUtils.find(this.allControlAreaList, (item) => item[valueProp] === value);
        return item ? item[labelField] + '(' + value + ')' : null;
      },
      //更改下拉框的值，默认更改整个row
      changeControl(value, scope) {
        if (value != '') {
          let item = XEUtils.find(
            this.allControlAreaList,
            (item) => item.controlAreaCode === value
          );
          scope.row.controlAreaName = item.controlAreaName;
        } else {
          scope.row.controlAreaName = null;
        }
        this.$refs.xTable.updateStatus(scope);
      },
      //保存
      addSure() {
        // let xTableValidFlag = true;
        // let uTableValidFlag = true;
        let status = false;
        //0.校验上级单位表格
        this.$refs.unitTable
          .validate()
          .then(() => {
            //1.校验控制范围表格
            this.$refs.xTable.validate().then(() => {
              const tableList = this.$refs.xTable.getTableData().fullData;
              //2.判断是否有重复的数据
              if (tableList.length > 1) {
                let start = 1;
                for (let n = 0; n < tableList.length; n++) {
                  if (status) {
                    break;
                  }
                  for (start; start < tableList.length; start++) {
                    if (n != start) {
                      status = isEqual(tableList[n], tableList[start], 'controlAreaCode');
                    }
                  }
                  start = n;
                }
              }
              if (status) {
                this.$message({
                  showClose: true,
                  message: this.$t('company.controlAreaSameData'),
                  type: 'error',
                });
                return;
              }
              //4.校验form
              this.$refs['departmentDialog'].validate((valid) => {
                if (valid && !this.loading) {
                  this.loading = true;
                  //如果点击的为公司，则上级部门编码为0；
                  if ('company' == this.detail.type) {
                    this.addInfo.parentDepartmentCode = '0';
                    this.addInfo.parentTreeCode = 0;
                    this.addInfo.belongCompanyCode =
                      this.detail.createCompanyCode || this.detail.belongCompanyCode;
                  }
                  if ('department' == this.detail.type) {
                    if ('company' == this.node.type) {
                      this.addInfo.parentDepartmentCode = '0';
                      this.addInfo.parentTreeCode = 0;
                      this.addInfo.belongCompanyCode = this.node.attributes.createCompanyCode;
                    } else if ('department' == this.node.type) {
                      this.addInfo.parentDepartmentCode =
                        this.node.attributes.createCompanyCode ||
                        this.node.attributes.createDepartmentCode;
                      this.addInfo.parentTreeCode = this.node.attributes.treeCode;
                      this.addInfo.belongCompanyCode = this.node.attributes.belongCompanyCode;
                    } else {
                      this.addInfo.parentDepartmentCode =
                        this.detail.createCompanyCode || this.detail.createDepartmentCode;
                      this.addInfo.parentTreeCode = this.detail.treeCode;
                      this.addInfo.belongCompanyCode =
                        this.detail.createCompanyCode || this.detail.belongCompanyCode;
                    }
                  }
                  if ('controlArea' == this.detail.type) {
                    if ('company' == this.node.type) {
                      this.addInfo.parentDepartmentCode = '0';
                      this.addInfo.parentTreeCode = 0;
                      this.addInfo.belongCompanyCode = this.node.attributes.createCompanyCode;
                    } else {
                      this.addInfo.parentDepartmentCode =
                        this.node.attributes.createCompanyCode ||
                        this.node.attributes.createDepartmentCode;
                      this.addInfo.parentTreeCode = this.node.attributes.treeCode;
                      this.addInfo.belongCompanyCode = this.node.attributes.belongCompanyCode;
                    }
                  }
                  this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
                  this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
                  this.addInfo.companyName = this.userInfo.userInfo.companyName;
                  this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
                  this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
                  this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
                  //控制范围
                  this.addInfo.controlAreaStr =
                    tableList.length == 0 ? null : JSON.stringify(tableList);
                  this.$axios.post(API.ADD_DEPARTMENT_API, this.addInfo).then((res) => {
                    this.loading = false;
                    if (0 != res.data.code) {
                      this.$alert(res.data.msg);
                    } else {
                      this.dialogAdd = false;
                      this.$emit('getData');
                      this.$message({
                        showClose: true,
                        message: res.data.msg || this.$t('message.success'),
                        type: 'success',
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
            console.log('00000');
          });
        // this.$refs.unitTable.validate((uTableValid) => {
        //   uTableValidFlag = uTableValid;
        //   if (uTableValid) {
        //     //1.校验控制范围表格
        //     this.$refs.xTable.validate((xTableValid) => {
        //       xTableValidFlag = xTableValid;
        //       if (xTableValid) {
        //         const tableList = this.$refs.xTable.getTableData().fullData;
        //         //2.判断是否有重复的数据
        //         if (tableList.length > 1) {
        //           let start = 1;
        //           for (let n = 0; n < tableList.length; n++) {
        //             if (status) {
        //               break;
        //             }
        //             for (start; start < tableList.length; start++) {
        //               if (n != start) {
        //                 status = isEqual(
        //                   tableList[n],
        //                   tableList[start],
        //                   "controlAreaCode"
        //                 );
        //               }
        //             }
        //             start = n;
        //           }
        //         }
        //         if (status) {
        //           this.$message({
        //             showClose: true,
        //             message: this.$t("company.controlAreaSameData"),
        //             type: "error",
        //           });
        //           return;
        //         }
        //         //4.校验form
        //         this.$refs["departmentDialog"].validate((valid) => {
        //           if (valid && !this.loading) {
        //             this.loading = true;
        //             //如果点击的为公司，则上级部门编码为0；
        //             if ("company" == this.detail.type) {
        //               this.addInfo.parentDepartmentCode = "0";
        //               this.addInfo.parentTreeCode = 0;
        //               this.addInfo.belongCompanyCode =
        //                 this.detail.createCompanyCode ||
        //                 this.detail.belongCompanyCode;
        //             }
        //             if ("department" == this.detail.type) {
        //               if ("company" == this.node.type) {
        //                 this.addInfo.parentDepartmentCode = "0";
        //                 this.addInfo.parentTreeCode = 0;
        //                 this.addInfo.belongCompanyCode = this.node.attributes.createCompanyCode;
        //               } else if ("department" == this.node.type) {
        //                 this.addInfo.parentDepartmentCode =
        //                   this.node.attributes.createCompanyCode ||
        //                   this.node.attributes.createDepartmentCode;
        //                 this.addInfo.parentTreeCode = this.node.attributes.treeCode;
        //                 this.addInfo.belongCompanyCode = this.node.attributes.belongCompanyCode;
        //               } else {
        //                 this.addInfo.parentDepartmentCode =
        //                   this.detail.createCompanyCode ||
        //                   this.detail.createDepartmentCode;
        //                 this.addInfo.parentTreeCode = this.detail.treeCode;
        //                 this.addInfo.belongCompanyCode =
        //                   this.detail.createCompanyCode ||
        //                   this.detail.belongCompanyCode;
        //               }
        //             }
        //             if ("controlArea" == this.detail.type) {
        //               if ("company" == this.node.type) {
        //                 this.addInfo.parentDepartmentCode = "0";
        //                 this.addInfo.parentTreeCode = 0;
        //                 this.addInfo.belongCompanyCode = this.node.attributes.createCompanyCode;
        //               } else {
        //                 this.addInfo.parentDepartmentCode =
        //                   this.node.attributes.createCompanyCode ||
        //                   this.node.attributes.createDepartmentCode;
        //                 this.addInfo.parentTreeCode = this.node.attributes.treeCode;
        //                 this.addInfo.belongCompanyCode = this.node.attributes.belongCompanyCode;
        //               }
        //             }
        //             this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
        //             this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
        //             this.addInfo.companyName = this.userInfo.userInfo.companyName;
        //             this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
        //             this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
        //             this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
        //             //控制范围
        //             this.addInfo.controlAreaStr =
        //               tableList.length == 0 ? null : JSON.stringify(tableList);
        //             this.$axios
        //               .post(API.ADD_DEPARTMENT_API, this.addInfo)
        //               .then((res) => {
        //                 this.loading = false;
        //                 if (0 != res.data.code) {
        //                   this.$alert(res.data.msg);
        //                 } else {
        //                   this.dialogAdd = false;
        //                   this.$emit("getData");
        //                   this.$message({
        //                     showClose: true,
        //                     message: res.data.msg || this.$t("message.success"),
        //                     type: "success",
        //                   });
        //                 }
        //               });
        //           } else {
        //             return false;
        //           }
        //         });
        //       }
        //     });
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
  .control-content {
    margin-top: 15px;
    margin-bottom: 10px;
  }
</style>
